module.exports = __webpack_public_path__ + "img/item-4.56a44c8.svg";